/**
 * File: referenceBook.js
 * Project: educore
 * Created Date: 2019-01-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ReferenceBookController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.resource = {}

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let resourceId = $state.params.resourceId;
        let plan = localStorageService.get("currentPlan")
        var save_url = TPWIZARDCONSTANT.API_SAVE_REFBOOK

        var validate = (resource) => {
            let errorCount = 0
            if (resource.name === null || resource.name === undefined || resource.name === "") {
                $scope.errors["name"] = "Please enter book name"
                errorCount++;
            }
            if (resource.author === null || resource.author === undefined || resource.author === "") {
                $scope.errors["author"] = "Please enter author name"
                errorCount++;
            }
            if (resource.publisher === null || resource.publisher === undefined || resource.publisher === "") {
                $scope.errors["publisher"] = "Please enter publisher name"
                errorCount++;
            }
            if (resource.isbn === null || resource.isbn === undefined || resource.isbn === "") {
                $scope.errors["isbn"] = "Please enter isbn "
                errorCount++;
            } else {
                var pattern = /((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i;
                if (!pattern.test(resource.web_link)) {
                    $scope.errors["web_link"] = "Please Enter a valid link";
                    errorCount++;
                }
            }
            return errorCount;
        }

        $scope.addResource = () => {
            var resource = {
                name: $scope.resource.name,
                author: $scope.resource.author,
                publisher: $scope.resource.publisher,
                isbn: $scope.resource.isbn,
                web_link: $scope.resource.web_link
            }
            $scope.errors = {}
            var errorCount = validate(resource);
            if (errorCount === 0) {
                authService.callAPI(save_url, "POST", {
                    tp_id: planId,
                    _id: resourceId,
                    title: $scope.resource.title,
                    name: $scope.resource.name,
                    author: $scope.resource.author,
                    publisher: $scope.resource.publisher,
                    isbn: $scope.resource.isbn,
                    web_link: $scope.resource.web_link,
                    status: $scope.resource.status,
                    user_id: userId
                }, (response) => {
                    if (response && response.result && response.result.data) {
                        var result = response.result.data;
                        toastr.success("Reference Book added successfully")
                        localStorageService.set("currentPlan", result)
                        $rootScope.setStatus(resourceId, result.status)
                        _.defer(function() {
                            $scope.$apply();
                        });
                    } else {
                        toastr.error("Network Error, please try later.")
                    }
                })
            }
        }

        $scope.resetResource = () => {
            $scope.resource.web_note = "";
            $scope.resource.web_link = "";
            $scope.errors = {};
        }

        var loadTemplate = () => {
            console.log(plan)
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })
                console.log($scope.resource)
                _.defer(() => {
                    $scope.$apply();
                });
            }
        }

         /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "refbooks"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }

    };
}

export default ReferenceBookController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/referenceBook.js